// extracted by mini-css-extract-plugin
export default {"text":"Forms_text__pU5TK","head":"Forms_head__i1ZaV","submit":"Forms_submit__gp5at"};